import { supabase } from '../../../lib/api'

const handlePoints = (points) => {
    if (points > 200) {
        return 200
    }

    return points
}

export const getPointsCurrentUser = async (userId) => {
    const { data, error } = await supabase.from('usuarios').select('*').eq('id_usuario', userId).single()

    if (error) {
        console.error('Error fetching points:', error)
    }

    if (!data) {
        return {
            earnedPoints: 0,
            spentPoints: 0,
            availablePoints: 0,
            pointsExpiringIn6Months: 0,
            pointsExpiringIn2Months: 0,
            expiredPoints: 0,
        }
    }

    const {
        intercanviar_pts_obtenidos,
        intercanviar_pts_gastados,
        intercanviar_pts_disponibles,
        intercanviar_pts_disponibles_tres_seis_meses,
        intercanviar_pts_disponibles_dos_meses,
        intercanviar_pts_caducados,
    } = data

    return {
        earnedPoints: handlePoints(intercanviar_pts_obtenidos) || 0,
        spentPoints: handlePoints(intercanviar_pts_gastados) || 0,
        availablePoints: handlePoints(intercanviar_pts_disponibles) || 0,
        pointsExpiringIn6Months: handlePoints(intercanviar_pts_disponibles_tres_seis_meses) || 0,
        pointsExpiringIn2Months: handlePoints(intercanviar_pts_disponibles_dos_meses) || 0,
        expiredPoints: handlePoints(intercanviar_pts_caducados) || 0,
    }
}
